const learn = {
  header: 'Learn + Earn',
  modules: 'Available micro-courses',
};

export default learn;
